// components以外の記載する可能性があるため
// ファイル名はapp.jsとします
import Vue from 'vue'; // import store from '@/vue/store'

import vueCustomElement from 'vue-custom-element';
Vue.use(vueCustomElement);
import 'document-register-element'; // IE対策
// 以下、Vue コンポーネントの読み込み
// ------------------------------

import NewsPage from '@/vue/components/news/index.vue';
Vue.customElement('v-news-page', NewsPage);
import StoreNewsPage from '@/vue/components/store/news/news-block.vue';
Vue.customElement('v-store-news-block', StoreNewsPage);
import RecruitPage from '@/vue/components/recruit/index.vue';
Vue.customElement('v-recruit-page', RecruitPage);
import KodawariModal from '@/vue/components/aboutus/giontsujiri/index-modal.vue';
Vue.customElement('v-kodawari-modal', KodawariModal);
import StoreMenus from '@/vue/components/store/menus/index.vue';
Vue.customElement('v-store-menus', StoreMenus);
import AllergyList from '@/vue/components/store/allergy/allergy-list.vue';
Vue.customElement('v-store-allergy', AllergyList);
import TopNews from '@/vue/components/top/news.vue';
Vue.customElement('v-top-news', TopNews);
import TopCalendar from '@/vue/components/top/calendar.vue';
Vue.customElement('v-top-calendar', TopCalendar);
import TopInstagram from '@/vue/components/top/instagram.vue';
Vue.customElement('v-top-instagram', TopInstagram);